// src/components/layout/RightPanel/LanguageLoader.jsx
import { LanguageSupport } from '@codemirror/language';

/* ========================
 * loadLanguageSupport - Cached language loading system
 * Preloads common languages and caches results
 * ======================== */

const languageCache = new Map();

const languageLoaders = {
    javascript: () => import('@codemirror/lang-javascript').then(m => m.javascript()),
    typescript: () => import('@codemirror/lang-javascript').then(m => m.javascript({ typescript: true })),
    jsx: () => import('@codemirror/lang-javascript').then(m => m.javascript({ jsx: true })),
    tsx: () => import('@codemirror/lang-javascript').then(m => m.javascript({ jsx: true, typescript: true })),
    python: () => import('@codemirror/lang-python').then(m => m.python()),
    html: () => import('@codemirror/lang-html').then(m => m.html()),
    css: () => import('@codemirror/lang-css').then(m => m.css()),
    json: () => import('@codemirror/lang-json').then(m => m.json()),
    markdown: () => import('@codemirror/lang-markdown').then(m => m.markdown()),
    sql: () => import('@codemirror/lang-sql').then(m => m.sql()),
    xml: () => import('@codemirror/lang-xml').then(m => m.xml()),
    java: () => import('@codemirror/lang-java').then(m => m.java()),
    rust: () => import('@codemirror/lang-rust').then(m => m.rust()),
    plaintext: () => Promise.resolve([])
};

export const loadLanguageSupport = async (language = 'plaintext') => {
    // Normalize language name
    const normalizedLang = language?.toLowerCase()?.replace(/[^a-z]/g, '') || 'plaintext';
    
    if (languageCache.has(normalizedLang)) {
        return languageCache.get(normalizedLang);
    }

    try {
        const loader = languageLoaders[normalizedLang] || languageLoaders.plaintext;
        const support = await loader();
        languageCache.set(normalizedLang, support);
        return support;
    } catch (error) {
        console.error(`Failed to load language support for ${language}:`, error);
        // Fallback to plaintext
        return languageLoaders.plaintext();
    }
};

// Preload common languages
export const preloadLanguages = async () => {
    const commonLanguages = ['javascript', 'typescript', 'jsx', 'python', 'html', 'css', 'json'];
    await Promise.all(commonLanguages.map(lang => loadLanguageSupport(lang)));
};